interface ACAReportingHeaderProps {
  planYear: number
  isFilingEligible: boolean
}

export default function ACAReportingHeader ({ planYear, isFilingEligible }: ACAReportingHeaderProps) {
  return (
    <>
      <div className='flex justify-between gap-2 items-center mb-2'>
        <div className='flex items-center'>
          <h1 className='heading-lg'>{planYear} ACA reporting</h1>
        </div>
      </div>

      <p className='text-gray-500 mb-6'>
        {isFilingEligible
          ? "To participate in Thatch's ACA reporting service, please complete the opt-in workflow in your Thatch dashboard by February 1, 2026. If you do not opt in by February 1, you will still receive your draft 1095 data as a .csv file to use with your own accountant, payroll provider, or ACA vendor."
          : 'Thatch will provide your 1095 data in a .csv file format for you to use with your own accountant, payroll provider, or ACA vendor.'}
      </p>
    </>
  )
}
